
import TheButton from "./TheButton.vue";

import getFromIdMixin from '@/mixins/getFromIdMixin';
import authMixin from '@/mixins/authMixin';
import currentuserDataMixin from '@/mixins/currentuserDataMixin';
// import { questions } from '@/_utils/data';
import { getDayDifference } from "@/_utils/helper";
import { isArabic } from '@/_utils/helper';

export default {
  mixins: [ getFromIdMixin, authMixin, currentuserDataMixin ],
  props: {
    question: {
      type: Object,
      required: true,
    },
  },
  components: {
    TheButton,
  },
  data(): any {
    return {
      language: "en",
      answersNumber: 0,
      text: "",
      owner: "",
      time: 0,
      likes: 0,
      id: 0,
      userImg: "",
      currentUserId: 0,

      currentLikeColor: "",
      currentBookmarkColor: "",
    };
  },
  async mounted(){
    await this.initializeValues();
    this.handleLanguage();
    this.setCurrentUser();
  },
  methods: {
    async setCurrentUser(){
      this.currentUserId = (await this.getCurrentUser()).currentUserId;
    },
    handleLanguage(){
      if (isArabic(this.text)) {
        this.language = "ar";
      } else {
        this.language = "en";
      }
    },
    handleAnswerClick(){
      this.handlePageRouting();
      this.$store.commit("toggleScrollToAnswer");
      // console.log(this.$store.state.scrollToAnswer);
    },
    async initializeValues(){
      this.answersNumber = this.question.answerIds.length;
      this.text = this.question.title;
      this.owner =  await this.getUserFromUniversityId(this.question.owner);
      this.time = this.question.pub_date;
      this.likes = this.question.likes;
      this.id = this.question.id;
      
      this.userImg = (await this.getUserFromUniversityId(this.question.owner)).picture;

      const currentUser = await this.currentUser();
      
      if (currentUser.likedQuestionIds.includes (this.id)) {
        this.currentLikeColor = this.$store.state.likePrimaryColor;
      } else {
        this.currentLikeColor = this.$store.state.likeSecondaryColor;
      }

      
      if (currentUser.bookmarkedQuestionIds.includes (this.id)) {
        this.currentBookmarkColor = this.$store.state.bookmarkPrimaryColor;
      } else {
        this.currentBookmarkColor = this.$store.state.bookmarkSecondaryColor;
      }

    },
    async toggleBookmark(){
        if (this.currentBookmarkColor !== this.$store.state.bookmarkPrimaryColor) {
          await this.bookmarkQuestion(this.id);
          // optimistic updates
          this.currentBookmarkColor = this.$store.state.bookmarkPrimaryColor;
        } else {
          await this.removeBookmarkQuestion(this.id);
          // optimistic updates
          this.currentBookmarkColor = this.$store.state.bookmarkSecondaryColor;
        }
    },
    async toggleLike(){
        if (this.currentLikeColor !== this.$store.state.likePrimaryColor) {
          await this.likeQuestion(this.id);
          // optimistic updates
          this.currentLikeColor = this.$store.state.likePrimaryColor;
          this.likes += 1;
        } else {
          await this.dislikeQuestion(this.id);
          // optimistic updates
          this.currentLikeColor = this.$store.state.likeSecondaryColor;
          this.likes -= 1;
        }
    },
    handlePageRouting(): void {
      this.$store.commit("setPageMode", "questionDetails");
    },
  },
};
